import React, {Component} from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import './booking.css';
import headerImage from '../../img/Trimmausasema-490x300.jpg';
import DigitalBookerApiClient from '../../utils/digital-booker-api-client';
import 'float-label-css/dist/float-label.css';

class BooktimeForm extends Component {

    static propTypes = {
        systemName: PropTypes.string,
        language: PropTypes.string,
        selections: PropTypes.object,
        extraFields: PropTypes.array
    };

    constructor(props) {
        super(props);
        moment.locale(this.props.language);
        this.validators = {};
        function notEmpty(candidate) {
            return candidate !== undefined && candidate.length > 0;
        }
        this.apiClient = this.props.apiClient ? this.props.apiClient : new DigitalBookerApiClient(this.props.systemName, this.props.language);
        this.validators.name = notEmpty;
        this.validators.phone = notEmpty;
        this.validators.email = function(candidate) {
            const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(candidate);
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.returnToCalendar = this.returnToCalendar.bind(this);
        this.canSubmit = this.canSubmit.bind(this);
        this.handleCheckboxChange  = this.handleCheckboxChange.bind(this);
        this.handleExtraInfoCheckboxChange = this.handleExtraInfoCheckboxChange.bind(this);
        const requiredExtraFields = {};
        const extraInfo = {};
        this.props.extraFields.forEach(field => {
            if(field.required === true) {
                requiredExtraFields[field.id] = true;
            }
            if(field.type === "multi_select") {
                extraInfo[field.id] = {};
                field.options.forEach(option => {
                    extraInfo[field.id][option.id] = false;
                });
            }
        });
        this.state = {name: '', email: '', phone: '', requiredExtraFields: requiredExtraFields, requiredFields: {name: true, email:true, phone: true, accept_terms: true}, invalidFields: {}, extraInfo: extraInfo, createdBooking: undefined, workInProgress: false};
    }

    handleChange(event, field, fieldContainer) {
        const newValue = event.target.value;
        this.setState((previousState) => {
            const newState = previousState;
            const stateContainer = fieldContainer ? newState[fieldContainer] : newState;
            stateContainer[field] = newValue;
            newState.invalidFields[field] = this.validators[field] !== undefined && !this.validators[field](newValue);
            if((newValue === '' || newValue === undefined) && (this.state.requiredExtraFields[field] || this.state.requiredFields[field])) {
                newState.invalidFields[field] = true;
            }
            return newState;
        });
    }

    handleCheckboxChange(field) {
        this.setState((previousState) => {
            if(previousState[field] === undefined) {
                previousState[field] = true;
            } else {
                previousState[field] = undefined;
            }
            return {previousState};
        });
    }

    handleExtraInfoCheckboxChange(optionsObjectField, objectField, field) {
        this.setState((previousState) => {
            const optionsObject = previousState[optionsObjectField];
            if(optionsObject[objectField]) {
                optionsObject[objectField][field] = optionsObject[objectField][field] !== true;
            } else {
                optionsObject[objectField] = {};
                optionsObject[objectField][field] = true;
            }
            return {[optionsObjectField]: optionsObject};
        });
    }

    handleSubmit(event) {
        this.setState(() => {
            return {workInProgress: true};
        });
        event.preventDefault();
        let sendOrderPromise;
        if(this.state.really_send_order === true) {
            sendOrderPromise = this.apiClient.bookTime(this.props.selections, {name: this.state.name, email: this.state.email, phone: this.state.phone, accept_terms: this.state.accept_terms}, this.state.extraInfo)
        } else {
            sendOrderPromise = this.apiClient.fakeBookTime(this.props.selections, {name: this.state.name, email: this.state.email, phone: this.state.phone, accept_terms: this.state.accept_terms}, this.state.extraInfo)
        }
        sendOrderPromise.then(bookingCreated => {
                this.setState(() => {
                    return {createdBooking: bookingCreated, workInProgress: false};
                })
            });
    }

    returnToCalendar() {
        return this.props.updateState("time_slot", undefined);
    }

    canSubmit() {
        const noInvalidValues = Object.keys(this.state.invalidFields).filter(iField => this.state.invalidFields[iField] === true).length === 0;
        const noMissingRequiredValues = Object.keys(this.state.requiredFields).filter(rField => this.state[rField] === undefined && this.state[rField] !== '').length === 0;
        const noMissingRequiredExtraValues = Object.keys(this.state.requiredExtraFields).filter(rField => this.state.extraInfo[rField] === undefined).length === 0;
        return noInvalidValues && noMissingRequiredValues && noMissingRequiredExtraValues;
    }

    render() {
        const inputField = (fieldName, placeHolder, type, example, fieldContainer) => {
            const stateContainer = fieldContainer ? this.state[fieldContainer] : this.state;
            const placeHolderText = (this.state.requiredFields[fieldName] || this.state.requiredExtraFields[fieldName]) ? placeHolder + " * " : placeHolder;
            return(
                <div className="has-float-label">
                    <input className={this.state.invalidFields[fieldName] ? "input-error": ""} id={fieldName+"-field"} placeholder={example} type={type} value={stateContainer[fieldName] || ''} onChange={(e) => this.handleChange(e, fieldName, fieldContainer)} />
                    <label htmlFor={fieldName+"-field"}>{placeHolderText}</label>
                </div>
            );
        };
        const form = () => {
            const canSubmit = this.canSubmit();
            return (
                <div className="booking-form">
                    <form className="order-form">
                        <div className="booking-form-box">
                            {this.props.extraFields.map((field, i) => {
                                if(field.type === "multi_select") {
                                    return (
                                        <div key={i}>
                                            <p>{field.name}</p>
                                            {field.options.map((option, i) => {
                                                return <div className="booking-checkbox" key={i}>
                                                        <input id={"extra-info-option-"+field.id+"-"+option.id} type="checkbox" onChange={() => this.handleExtraInfoCheckboxChange('extraInfo', field.id, option.id)} />
                                                        <label htmlFor={"extra-info-option-"+field.id+"-"+option.id}>{option.name}</label>
                                                    </div>
                                            })}
                                        </div>
                                    );
                                } else {
                                    return (<div key={i}>{inputField(field.id, field.name, "text", field.name, 'extraInfo')}</div>);
                                }
                            })}
                        </div>
                        <div className="booking-form-box">
                            {inputField("name", "Nimi", "text", "Etunimi Sukunimi")}
                            {inputField("email", "Sähköpostiosoite", "email", "etunimi.sukunimi@example.fi")}
                            {inputField("phone", "Puhelinnumero", "phone", "0501234525")}
                            <div className="booking-checkbox">
                                <input className={this.state.invalidFields['accept_terms'] ? "input-error": ""} id="accept_terms-field" type="checkbox" value={this.state.accept_terms} onChange={(e) => this.handleCheckboxChange("accept_terms")} />
                                <label htmlFor="accept_terms-field">
                                    Olen lukenut ja hyväksyn&nbsp;
                                </label>
                                <a target="_blank" href={"https://www.varaaheti.fi/"+this.props.systemName+"/"+this.props.language+"/content/terms"}>käyttöehdot</a>
                            </div>
                            <div className="booking-checkbox">
                                <input id="really-send-order-field" type="checkbox" value={this.state.really_send_order} onChange={(e) => this.handleCheckboxChange("really_send_order")} />
                                <label htmlFor="really-send-order-field">
                                    Lähetä tilaus ihan oikeasti
                                </label>
                            </div>
                        </div>
                        <div className="booking-buttons">
                            <a id="submit-booking-link" onClick={canSubmit ? this.handleSubmit : () => {}} className={canSubmit ? "booking-button" : "disabled-button"}>Varaa aika</a>
                        </div>
                        <div className="booking-buttons">
                            <a onClick={this.returnToCalendar} className="booking-button">Palaa ajanvalintaan</a>
                        </div>
                    </form>
                </div>)
        };

        const confirmation = () => {
            return (
                <div className="booking-confirmation">
                    <h4>Aika varattu</h4>
                </div>
            );
        };

        return (
          <div className="booking-order">
              <img src={headerImage} alt="header" className="img-responsive booking-image"/>
              <div className="booking-info">
                  <h1>{this.props.selections.service.name} </h1>
                  <h5>{this.props.selections.category.name}</h5>
                  <ul>
                      {
                      this.props.selections.extra_services.map((selectedExtraServiceId, i) => {
                          return <li key={i}>{this.props.selections.service.extra_services.filter(extraService => extraService.id.toString() === selectedExtraServiceId.toString()).map(extraService => extraService.name)}</li>
                      })
                  }
                  </ul>
                  <h2>{this.props.selections.time_slot.title}</h2>
                  <p>
                      {this.props.selections.location.name} <br/>
                      {moment(this.props.selections.time_slot.start).format('LL')} <br/>
                      {moment(this.props.selections.time_slot.start).format('LT')} - {moment(this.props.selections.time_slot.end).format('LT')} <br/>
                  </p>
              </div>
              {this.state.createdBooking === undefined ? form() : confirmation()}
          </div>
        );
    }
}

export default BooktimeForm;


// WEBPACK FOOTER //
// ../components/booking/BooktimeForm.js